// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2vs79","row":"Node_row__1Jbxl","label":"Node_label__1chvK","footer":"Node_footer__1Cxwd"};